import { useMutation } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';

export interface CallTokenResult {
  call: {
    id: string;
    room: string;
    state: string;
    caller: { id: string };
    callee: { id: string };
  };
  token: string | null;
  url: string;
}

/**
 * Place a call to another account in the caller's workspace. Resolves with the
 * caller's LiveKit token + server url so the caller can join the room and wait
 * for the callee to answer (≈ Slack calls.add).
 */
export const useStartCall = () => {
  const fetcherFn = useFetcher<
    { call: { startCall: CallTokenResult } },
    { input: { calleeId: string } }
  >(START_CALL);

  return useMutation({
    mutationFn: async (calleeId: string): Promise<CallTokenResult> => {
      const data = await fetcherFn({ input: { calleeId } });
      return data.call.startCall;
    },
  });
};

const START_CALL = `
  mutation START_CALL($input: StartCallInput!) {
    call {
      startCall(input: $input) {
        call {
          id
          room
          state
          caller { id }
          callee { id }
        }
        token
        url
      }
    }
  }
`;
